/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Dealinformation2Inputs */

const en_coinvestments_nav_dealinformation2 = /** @type {(inputs: Coinvestments_Nav_Dealinformation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal Overview`)
};

/**
* | output |
* | --- |
* | "Deal Overview" |
*
* @param {Coinvestments_Nav_Dealinformation2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_dealinformation2 = /** @type {((inputs?: Coinvestments_Nav_Dealinformation2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Dealinformation2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_dealinformation2(inputs)
});
export { coinvestments_nav_dealinformation2 as "coInvestments_nav_dealInformation" }